import labelsJson from '@/data/labels.json';
import { z } from 'zod';

const LabelSet = z.record(z.string(), z.string().optional());
const LabelType = z
    .object({
        _global: LabelSet,
    })
    .and(z.record(z.string(), LabelSet.optional()));

const labels = LabelType.safeParse(labelsJson);

export const fieldLabel = (fieldName: any, schemaName?: string): string | undefined => {
    if (!labels.success) {
        return;
    }
    if (typeof fieldName !== 'string') return;
    if (schemaName == null) {
        return labels.data._global[fieldName];
    }
    const fromSchema = labels.data[schemaName]?.[fieldName];
    return fromSchema ?? labels.data._global[fieldName];
};
